import { UsageList } from "routes/SnippetsPage/components/UsageList";
import type { SnippetDefinition } from "routes/SnippetsPage/registry";

type SnippetCardProps = {
  snippet: SnippetDefinition;
};

/**
 * 1 コンポーネントぶんの展示枠。ID・名前・説明・全バリアント描画・使用箇所。
 * @param {SnippetCardProps} props スニペット定義
 * @return {JSX.Element} カード
 */
export const SnippetCard = ({ snippet }: SnippetCardProps): JSX.Element => {
  return (
    <section
      id={snippet.id}
      className="border border-base-300 rounded-lg bg-base-100 p-4 space-y-3"
    >
      <header className="flex items-start justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-mono text-xs text-base-content/60">
              {snippet.id}
            </span>
            <h3 className="text-base font-bold">{snippet.name}</h3>
            <span className="badge badge-sm badge-outline">{snippet.kind}</span>
          </div>
          <p className="text-xs text-base-content/60 mt-1">
            {snippet.description}
          </p>
          <p className="text-[10px] text-base-content/40 font-mono mt-1">
            {snippet.source}
          </p>
        </div>
      </header>

      <div className="bg-base-200/40 rounded p-3">{snippet.render()}</div>

      <UsageList snippetId={snippet.id} />
    </section>
  );
};
